import { ColorSwatch as RACColorSwatch, type ColorSwatchProps as RACColorSwatchProps } from "react-aria-components";
import { css, cva, type RecipeVariantProps } from "../../../../styled-system/css";
import type { SystemStyleObject } from "../../../../styled-system/types";

const colorSwatchRecipe = cva({
  base: {
    display: "inline-block",
    flexShrink: 0,
    border: "1px solid {colors.lightgrey}",
  },
  variants: {
    size: {
      small: {
        width: "16px",
        height: "16px",
      },
      medium: {
        width: "24px",
        height: "24px",
      },
      large: {
        width: "32px",
        height: "32px",
      },
    },
    shape: {
      round: {
        borderRadius: "full",
      },
      square: {
        borderRadius: "light",
      },
    },
  },
  defaultVariants: {
    size: "medium",
    shape: "round",
  },
});

type ColorSwatchVariants = RecipeVariantProps<typeof colorSwatchRecipe>;

type ColorSwatchProps = ColorSwatchVariants &
  Omit<RACColorSwatchProps, "color" | "className" | "style"> & {
    color?: RACColorSwatchProps["color"] | null;
    css?: SystemStyleObject;
  };

export function ColorSwatch({ color, size, shape, css: cssProp, ...props }: ColorSwatchProps) {
  return (
    <RACColorSwatch
      {...props}
      className={css(colorSwatchRecipe.raw({ size, shape }), cssProp)}
      style={({ color }) => ({ background: color.toString("css") })}
      color={color ?? undefined}
    />
  );
}
